module.exports = __webpack_public_path__ + "img/2.c7e266c3.png";